import { createBrowserRouter } from "react-router-dom";
import { Home } from "./pages/home";
import { Login } from "./pages/login";
import { PasswordReset } from "./pages/password-reset";
import { NewReg } from "./pages/new-registration";
import { Register } from "./pages/register";
import { RegisterReffered } from "./pages/register-reffered";
import { OTP } from "./pages/otp";
import { RegisterSuccess } from "./pages/register-sucess";
import PersistLogin from "./common/components/persistence/PersistLogin";
import { RequireAuth } from "./common/components/requireAuth";
import { Dashboard } from "./pages/dashboard/layout";
import { NotFound } from "./pages/404";
import { Layout } from "./layout";
import { Stats } from "./pages/dashboard/stats";
import { Products } from "./pages/dashboard/products";
import { ProductDetailsPage } from "./pages/dashboard/players/product-details";
import { AddInventory } from "./pages/dashboard/add-inventory";
import { Orders } from "./pages/dashboard/orders";
import { MyDistributors } from "./pages/dashboard/my-distributors";
import { MakeOrder } from "./pages/dashboard/make-order";
import { Settings } from "./pages/dashboard/settings";
import { Invoices } from "./pages/dashboard/invoices";
import { Invoice } from "./pages/dashboard/invoices/subs/view";
import { Delivery } from "./pages/dashboard/delivery";
import { NewDelivery } from "./pages/dashboard/delivery/new-delivery";
import { Requests } from "./pages/dashboard/requests";
import { Companies } from "./pages/dashboard/admin/companies";
import { ComapanyDetails } from "./pages/dashboard/admin/company-details";
import { Rfq } from "./pages/dashboard/rfq";
import { ViewRFQ } from "./pages/dashboard/rfq/view-rfq";
import { RespondRfq } from "./pages/dashboard/rfq/respond-rfq";
import { NewRFQ } from "./pages/dashboard/rfq/new-rfq";
import { EditRfq } from "./pages/dashboard/edit-rfq";
import { AdminProducts } from "./pages/dashboard/admin/products";
import { AdminProductDetails } from "./pages/dashboard/admin/product-details";
import { InviteCompanies } from "./pages/dashboard/nafdac/invite-companies";
import OurTeam from "./pages/our-team";
import Portfolio from "./pages/portfolio";
import AdminDashboard from "./pages/dashboard/admin/dashboard";
import DRF from "./pages/dashboard/admin/drf";
import { RegisterInvited } from "./pages/register-invited";
import { StateMinistryStats } from "./pages/dashboard/stats/subs/stateMinistryStat";
import { MinistryAdminStats } from "./pages/dashboard/stats/subs/ministryAdminStats";
import DRF_Transactions from "./pages/dashboard/admin/transactions.tsx";
import HospitalHeadFinancial from "./pages/dashboard/hospital-head/drf/financial/financial";
import HospitalHeadReport from "./pages/dashboard/hospital-head/drf/report/report";
import PharmacyHeadStat from "./pages/dashboard/pharmacy-head/stat";
import PharmacyHeadFinancialManagement from "./pages/dashboard/pharmacy-head/financial-management";
import DGHealthDashboard from "./pages/dashboard/dg-health/financials";
import Retailer from "./pages/dashboard/drf";
import DRFUser from "./pages/dashboard/drf/user-management";
import StateDashboard from "./pages/dashboard/state-secretariat";
import FundAllocationHistory from "./pages/dashboard/state-secretariat/fund-history";
import SecreataryFinancials from "./pages/dashboard/state-secretariat/financial-management";
import DRFFacility from "./pages/dashboard/state-secretariat/financial-management/DRFFacility";
import AccountantFinancials from "./pages/dashboard/accountant/financial";
import AccountantAudit from "./pages/dashboard/accountant/audit";

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "", element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "reset-password", element: <PasswordReset /> },
      { path: "register", element: <NewReg /> },
      { path: "old-registrationadf", element: <Register /> },
      { path: "register/referred", element: <RegisterReffered /> },
      { path: "register/invited", element: <RegisterInvited /> },
      { path: "otp", element: <OTP /> },
      { path: "register/success", element: <RegisterSuccess /> },
      { path: "our-team", element: <OurTeam /> },
      { path: "portfolio", element: <Portfolio /> },
      { path: "*", element: <NotFound /> },
    ],
  },

  {
    element: <PersistLogin />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          {
            path: "/dashboard/",
            element: <Dashboard />,

            children: [
              { path: "stats", element: <Stats /> },
              { path: "products", element: <Products /> },
              { path: "products/:id", element: <ProductDetailsPage /> },
              { path: "inventories", element: <AddInventory /> },
              { path: "requisition", element: <Orders /> },
              { path: "my-team/:companyType", element: <MyDistributors /> },
              { path: "requisition/make-requisition", element: <MakeOrder /> },
              { path: "settings", element: <Settings /> },
              { path: "invoices", element: <Invoices /> },
              { path: "invoices/:quotationId", element: <Invoice /> },
              { path: "deliveries", element: <Delivery /> },
              {
                path: "deliveries/new-delivery-request",
                element: <NewDelivery />,
              },
              { path: "requests/:companyType", element: <Requests /> },
              {
                path: "admin/companies/dashboard",
                element: <AdminDashboard />,
              },
              {
                path: "admin/companies/drf",
                element: <DRF />,
              },
              {
                path: "retailer/drf",
                element: <Retailer />,
              },
              {
                path: "retailer/drf/user-management",
                element: <DRFUser />,
              },
              {
                path: "dg-health/financials",
                element: <DGHealthDashboard />,
              },
              {
                path: "admin/companies/transactions",
                element: <DRF_Transactions />,
              },
              {
                path: "hospital-head/financials/drf",
                element: <HospitalHeadFinancial />,
              },
              {
                path: "hospital-head/report/drf",
                element: <HospitalHeadReport />,
              },
              {
                path: "pharmacyHead/stat",
                element: <PharmacyHeadStat />,
              },
              {
                path: "pharmacyHead/financials",
                element: <PharmacyHeadFinancialManagement />,
              },
              {
                path: "accountant/financials",
                element: <AccountantFinancials />,
              },
              {
                path: "accountant/audit",
                element: <AccountantAudit />,
              },
              {
                path: "state-sec/dashboard/drf",
                element: <StateDashboard />,
              },
              {
                path: "state-sec/fund-allocation/drf/:rowId",
                element: <FundAllocationHistory />,
              },
              {
                path: "state-sec/financials/drf",
                element: <SecreataryFinancials />,
              },
              {
                path: "state-sec/drf-facility/drf/:rowId",
                element: <DRFFacility />,
              },
              { path: "admin/companies/queried", element: <Companies /> },
              { path: "admin/companies/approved", element: <Companies /> },
              { path: "admin/companies/declined", element: <Companies /> },
              { path: "admin/companies/pending", element: <Companies /> },
              {
                path: "admin/companies/details/:id/:type",
                element: <ComapanyDetails />,
              },
              {
                element: (
                  <RequireAuth allowedRoles={["retailer", "distributor"]} />
                ),
                children: [
                  { path: "rfq", element: <Rfq /> },
                  { path: "rfq/retailer/view-rfq/:id", element: <ViewRFQ /> },
                  {
                    path: "rfq/distributor/view-rfq/:id",
                    element: <RespondRfq />,
                  },
                  { path: "rfq/make-rfq", element: <NewRFQ /> },
                  { path: "rfq/edit-rfq", element: <EditRfq /> },
                ],
              },
              { path: "admin/products/queried", element: <AdminProducts /> },
              { path: "admin/products/approved", element: <AdminProducts /> },
              { path: "admin/products/declined", element: <AdminProducts /> },
              { path: "admin/products/pending", element: <AdminProducts /> },
              {
                path: "admin/products/details/:type/:id",
                element: <AdminProductDetails />,
              },
              {
                path: "pcn-admin/invite-companies",
                element: <InviteCompanies />,
              },
              {
                path: "ministry-admin",
                element: <MinistryAdminStats />,
              },
              {
                path: "state-ministry",
                element: <StateMinistryStats />,
              },
              { path: "*", element: <NotFound /> },
            ],
          },
        ],
      },
    ],
  },
]);
